













export default {
  name: 'MenuIcon',
  props: {
    small: Boolean,
    alt: Boolean
  }
};
